import classNames from "classnames"
import React from "react"

export default function Button({
  children,
  active,
  disabled,
  onClick,
}: {
  children: any
  active?: boolean
  disabled?: boolean
  onClick?: () => void
}) {
  return (
    <div
      onClick={() => onClick?.()}
      className={classNames(
        "shrink-0 flex items-start justify-start p-2 rounded border cursor-pointer select-none",
        {
          "border-gray-200 dark:border-gray-700 text-zinc-200  dark:text-zinc-500":
            disabled,
          "bg-gray-50 dark:bg-gray-600 hover:bg-sky-100 dark:hover:bg-sky-800 border-gray-300 dark:border-gray-500 text-zinc-600  dark:text-zinc-300":
            !disabled && !active,
          "bg-sky-300 dark:bg-sky-500 dark:border-sky-700": active,
        }
      )}
    >
      {children}
    </div>
  )
}
